import { Injectable } from '@angular/core';
import { CaptureVideoOptions, MediaCapture, MediaFile } from '@awesome-cordova-plugins/media-capture/ngx';
import { Camera, ImageOptions, Photo } from '@capacitor/camera';
import { Platform } from '@ionic/angular';
import { MediaType } from '@models/imported/SagaBase';
import { ImagesSettingsService } from '@services/settings';
import { MediaSource } from '../../schema/enums/media-source';
import { ICustomFile } from '../../schema/interfaces/ICustomFile';
import { CaptureOptionsFactoryService } from '../capture-options-factory/capture-options-factory.service';

@Injectable()
export class CameraBridgeService {
  constructor(
    private platform: Platform,
    private mediaCapture: MediaCapture,
    private imagesSettings: ImagesSettingsService,
    private captureOptionsService: CaptureOptionsFactoryService
  ) {}

  getPicture(mediaSource: MediaSource.Camera | MediaSource.Gallery): Promise<ICustomFile> {
    const imageOptions: ImageOptions = this.captureOptionsService.createImageOptions(mediaSource);
    return Camera.getPhoto(imageOptions).then(cameraPhoto => this.createCustomFileFromPhoto(cameraPhoto));
  }

  captureVideo(): Promise<ICustomFile> {
    const captureVideoOptions: CaptureVideoOptions = this.captureOptionsService.createVideoOptions();
    return this.mediaCapture.captureVideo(captureVideoOptions).then(mediaFiles => this.createCustomFileFromVideo(mediaFiles[0]));
  }

  private createCustomFileFromPhoto(cameraPhoto: Photo): ICustomFile {
    const customFile: ICustomFile = {
      uri: cameraPhoto.path,
      url: cameraPhoto.webPath,
      file: null,
      parent: null,
      dataType: MediaType.Image
    };

    return customFile;
  }

  private createCustomFileFromVideo(mediaFile: MediaFile): ICustomFile {
    let filePath = mediaFile.fullPath;
    if (this.platform.is('ios')) {
      filePath = `file://${filePath}`;
    }
    const videoAttachmentsIcon: string = this.imagesSettings.get('VideoAttachments');
    const preview: string = videoAttachmentsIcon ? videoAttachmentsIcon.substring(videoAttachmentsIcon.indexOf(',') + 1) : '';

    const customFile: ICustomFile = {
      uri: filePath,
      url: null,
      file: null,
      parent: null,
      dataType: MediaType.Video,
      size: mediaFile.size,
      data: preview
    };

    return customFile;
  }
}
